import { Module } from '@/modules/core/app/constants/app.constants';
import { StatusPageRouteNames } from '@/modules/core/statuspage/statuspage.constants';
import { StatusPageRouteConfig } from '@/modules/core/statuspage/StatusPageRouteConfig';

export const router = StatusPageRouteConfig.factory(
  [
    {
      path: `/${StatusPageRouteNames.STATUS_PAGE}`,
      name: StatusPageRouteNames.STATUS_PAGE,
      component: () => import(/* webpackChunkName: "status-page" */ './pages/StatusPage.vue'),
    },
  ],
  Module.STATUSPAGE
);
